<template>
  <main class="wrapper_full" :class="{ wrapper_logo: !checkWidgetsShow }">
    <v-container class="py-10">
      <template v-if="checkWidgetsShow">
        <div>
          <div class="w-100 d-flex align-center justify-end mb-5">
            <span class="mr-5 primary--text f14 font-weight-medium">
              {{ localStorage.translations.pages.common.text['drag_n_drop'] }}
            </span>
            <BaseInput type="switch" v-model="enableDragNDrop" />
          </div>
          <div class="widgets gap-5">
            <draggable
              v-for="(column, columnKey) in widgetColumns"
              :key="'column_' + columnKey"
              class="widgets__col gap-5"
              :list="column"
              :animation="200"
              :disabled="!enableDragNDrop"
              ghost-class="ghost-card"
              group="column"
              @change="definePosition()"
            >
              <template v-for="(widget, widgetKey) in column">
                <HomeWidget
                  v-if="
                    defaultWidgetData[widget.name].access
                      ? $userCheckAccess({ abilities: defaultWidgetData[widget.name].access, checkUserType: defaultWidgetData[widget.name].userType })
                      : true
                  "
                  :key="widgetKey"
                  :data="
                    Object.keys(widgets[widget.name]).length > 0 && widgets[widget.name].data
                      ? widgets[widget.name].data
                      : commonWidgetsShow[widget.name]
                  "
                  :dataKey="widget.name"
                  :reports="widget.name === 'reports'"
                />
              </template>
            </draggable>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="content">
          <img v-if="companiesConfig.logo" :src="companiesConfig.logo.svg" />
          {{ localStorage.translations.pages.home.main['dobro-pozhalovat-v-acs-proapp'] }}
        </div>
      </template>
    </v-container>
  </main>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import HomeWidget from 'components/homeWidgets/HomeWidget'
import draggable from 'vuedraggable'
import BaseInput from 'components/base/BaseInput.vue'
import { enable } from 'core-js/internals/internal-metadata'
export default {
  name: 'Home',
  components: { BaseInput, HomeWidget, draggable },
  data: () => ({
    widgets: {
      projects_in_progress: {},
      projects_expiring: {},
      employees_status: {},
      reports: {},
      invoices: {},
    },
    widgetColumns: [
      [
        { name: 'projects_in_progress', id: 1 },
        { name: 'projects_expiring', id: 2 },
      ],
      [{ name: 'employees_status', id: 3 }],
      [
        { name: 'reports', id: 4 },
        { name: 'invoices', id: 5 },
      ],
    ],
    defaultWidgetData: {
      projects_in_progress: { id: 1, access: 'view_client_project' },
      projects_expiring: { id: 2, access: 'view_client_project' },
      employees_status: { id: 3, access: 'view_client_project', userType: 'user' },
      reports: { id: 4, access: 'view_project_reports' },
      invoices: { id: 5, access: 'view_invoices' },
    },
    enableDragNDrop: false,
    period: [],
    isSavePositionInProgress: false,
  }),
  created() {
    if (this.checkAccess) {
      this.getPeriodDateData()
      this.onCommonWidgetsShow({ period: this.period })
      this.getUserData()
    }
  },
  computed: {
    ...mapGetters(['companiesConfig']),
    ...mapState('commonWidgets', ['commonWidgetsShow']),
    accessValuesIsShowWidgets() {
      return Object.values(this.defaultWidgetData)
        .filter((item) => item.access)
        .map((item) => item.access)
    },
    checkAccess() {
      return this.accessValuesIsShowWidgets.some((i) => this.$userCheckAccess({ abilities: i }))
    },
    checkWidgetsShow() {
      return this.checkAccess && this.commonWidgetsShow
    },
  },
  methods: {
    enable,
    ...mapActions('commonWidgets', ['onCommonWidgetsShow']),
    ...mapActions('user', ['onGetOnlineUserData', 'onPutOnlineUserDataSettings']),
    definePosition() {
      if (!this.isSavePosition) {
        this.isSavePosition = true
        let data = {
          widgetsPosition: this.widgetColumns,
        }
        this.onPutOnlineUserDataSettings({ data })
          .then(() => {
            this.getUserData()
          })
          .finally(() => (this.isSavePosition = false))
      }
    },
    async getUserData() {
      await this.onGetOnlineUserData().then((res) => {
        if (res.data.data.settings && res.data.data.settings.widgetsPosition.length > 0) {
          this.widgetColumns = res.data.data.settings.widgetsPosition
        }
      })
    },
    getPeriodDateData() {
      let currentDate = new Date()
      let dd = currentDate.getDate()
      let mm = currentDate.getMonth() + 1
      let yyyy = currentDate.getFullYear()
      this.period = []
      let currentMonth = new Date(yyyy, mm, 0).getDate()
      let lastMonth = new Date(yyyy, mm - 1, 0).getDate()
      if (currentMonth > lastMonth) {
        let tempDay = dd - (dd - lastMonth)
        this.period.push(
          String(
            yyyy +
              '-' +
              String(mm == 1 ? 12 : mm - 1).padStart(2, '0') +
              '-' +
              String(tempDay).padStart(2, '0'),
          ),
        )
        this.period.push(
          String(yyyy + '-' + String(mm).padStart(2, '0') + '-' + String(dd).padStart(2, '0')),
        )
      } else {
        this.period.push(
          String(
            yyyy +
              '-' +
              String(mm == 1 ? 12 : mm - 1).padStart(2, '0') +
              '-' +
              String(dd).padStart(2, '0'),
          ),
        )
        this.period.push(
          String(yyyy + '-' + String(mm).padStart(2, '0') + '-' + String(dd).padStart(2, '0')),
        )
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.ghost-card {
  opacity: 0.5;
  background: #f7fafc;
  border: 1px solid #4299e1;
}
.wrapper_full {
  display: grid;
  // height: calc(100vh - 60px) !important;
  .container {
    display: grid;
    align-items: start;
    .content {
      display: grid;
      grid-template-columns: 1fr;
      justify-content: center;
      justify-items: center;
      grid-row-gap: 40px;
      font-size: 30px;
      text-align: center;
      @media #{map-get($display-breakpoints, 'sm-and-down')} {
        font-size: 26px;
      }
      img {
        width: 100%;
        height: auto;
        max-height: 200px;
        max-width: 500px;
      }
    }
    .widgets {
      max-height: 100%;
      height: 100%;
      // display: flex;
      grid-template-columns: 1fr;
      display: grid;
      // grid-template-columns: minmax(460px,33%) minmax(400px, 33% ) minmax(580px, 33%);
      // flex-wrap: wrap;
      @media screen and (min-width: 600px) {
        grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
      }
      &__col {
        display: flex;
        flex-direction: column;
        align-items: start;
      }
    }
  }
}
.wrapper_logo {
  .container {
    align-items: center;
  }
}
</style>
